import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptors } from "./api";

// initialize an empty api service that we'll inject endpoints into later as needed
export default createApi({
  baseQuery: baseQueryWithInterceptors,
  tagTypes: [
    "BulkLicenses",
    "Licenses",
    "License",
    "Applications",
    "Application",
    "Invoices",
    "Invoice",
    "Tenants",
    "Tenant",
    "IamUser",
    "Accounts",
    "Config",
    "Fixtures",
    "Documents",
  ],
  endpoints: () => ({}),
});

export const getInvalidationTags =
  (defaultTags = []) =>
  (res, err, { invalidatesTag }) => {
    const tags = [...defaultTags];
    if (invalidatesTag?.length) tags.push(...invalidatesTag.filter(Boolean));
    return tags;
  };

export const getProvidesTags =
  (defaultTags = []) =>
  (res, err, { providesTag }) => {
    const tags = [...defaultTags];
    if (providesTag?.length) tags.push(...providesTag.filter(Boolean));
    return tags;
  };
